import React from 'react';
import JumpPagePagination from '.';
import { PAGINATION_PAGE_TYPE } from '~/config';

const PaginationRenderItem = ({
  pageType,
  prefix,
  page,
  currentPageOfCategoryPageTemplate,
  originalElement,
  absoluteHref = '',
}) => {
  switch (pageType) {
    case PAGINATION_PAGE_TYPE.PAGE:
      return (
        <a
          href={absoluteHref ? absoluteHref : `${prefix}&page=${page}`}
          onClick={(e) => e.preventDefault()}
        >
          {page}
        </a>
      );
    case PAGINATION_PAGE_TYPE.PREV:
      return (
        <a
          href={
            absoluteHref
              ? absoluteHref
              : `${prefix}&page=${currentPageOfCategoryPageTemplate - 1}`
          }
          onClick={(e) => e.preventDefault()}
        >
          {'<'}
        </a>
      );
    case PAGINATION_PAGE_TYPE.NEXT:
      return (
        <a
          href={
            absoluteHref
              ? absoluteHref
              : `${prefix}&page=${currentPageOfCategoryPageTemplate + 1}`
          }
          onClick={(e) => e.preventDefault()}
        >
          {'>'}
        </a>
      );
    case PAGINATION_PAGE_TYPE.JUMP_PREV:
      return (
        <JumpPagePagination
          type="jump-prev"
          href={
            absoluteHref
              ? absoluteHref
              : `${prefix}&page=${currentPageOfCategoryPageTemplate - 5}`
          }
          onClick={(e) => e.preventDefault()}
        />
      );
    case PAGINATION_PAGE_TYPE.JUMP_NEXT:
      return (
        <JumpPagePagination
          type="jump-next"
          href={
            absoluteHref
              ? absoluteHref
              : `${prefix}&page=${currentPageOfCategoryPageTemplate + 5}`
          }
          onClick={(e) => e.preventDefault()}
        />
      );
    default:
      return originalElement;
  }
};

export default PaginationRenderItem;
